<template>
  <b-container fluid>
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>Filtros de Busca</strong>
        </h4>
        <a-form layout="vertical">
          <div class="row">
            <div v-if="sysAdminUser" class="col-md-4">
              <a-form-item label="Canal de Venda">
                <a-select
                  v-model="filtrosLocal.idSalechannel"
                  @change="handleSaleChannelChange"
                >
                  <a-select-option value=""> Selecione </a-select-option>
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in saleChannels"
                    :key="`saleChannels-${index}`"
                  >
                    {{ item.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-4" v-if="showCostCenter">
              <a-form-item label="Centro de Custo">
                <a-select default-value="0" v-model="filtrosLocal.idCostCenter">
                  <a-select-option value="0"> Selecione </a-select-option>
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in costCenters"
                    :key="`costCenters-${index}`"
                  >
                    {{ item.description }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <div class="col-md-4">
              <a-form-item label="Estabelecimento">
                <v-select
                  label="name"
                  :filterable="false"
                  :options="merchants"
                  :reduce="(merchant) => merchant.id"
                  v-model="filtrosLocal.idMerchant"
                  @search="onSearch"
                >
                  <template slot="no-options">Pesquisar Estabelecimento</template>
                  <template slot="option" slot-scope="option">{{
                    option.name
                  }}</template>
                  <template slot="selected-option" slot-scope="option">{{
                    option.name
                  }}</template>
                </v-select>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
            </div>
            <div class="col-md-2">
              <b-button
                class="col-12"
                @click="filtrar"
                variant="outline-primary"
                >Filtrar</b-button
              >
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card">
        <div class="card-body">


<div class="row">
      <div class="col-lg-12 mt-2 mb-2">
        <h5 class="text-black"><strong>Aguardando Informações</strong></h5>
        <p class="text-muted">
          Este relatório tem por finalidade destacar cadastros quais ainda não podem ser ativados na adquirente por ausencia de Informações
        </p>
      </div>
    </div>

          <!-- Main table element -->
          <b-table
            show-empty
            stacked="md"
            striped
            :borderless="true"
            :items="displayItens"
            :fields="fields"
            :per-page="perPage"
            :filter="filter"
          >
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click="goToEdit(row.item.idMerchant)"
                ><i class="fe fe-edit"></i
              ></b-button>
            </template>
            <template v-slot:cell(document)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(email)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(name)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(birthDate)="row"><span class="fe fe-check-circle success" v-if="row.item.idMerchantType == 1 || row.item.birthDate" /><span class="fa fa-times-circle error" v-else /> {{ row.item.idMerchantType != 1 && row.item.birthDate ? moment(row.item.birthDate).format("DD/MM/YYYY") : '' }}</template>
            <template v-slot:cell(zipCode)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(district)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(street)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(number)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(socialReason)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(managerName)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(managerDocument)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{text.value}}</template>
            <template v-slot:cell(managerBirthDate)="text"><span class="fe fe-check-circle success" v-if="text.value" /><span class="fa fa-times-circle error" v-else /> {{ text.value ? moment(text.value).format("DD/MM/YYYY") : '' }}</template>
          </b-table>
        </div>
      </div>
    </template>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @input="onChangePage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<style lang="scss">
@import '../../../assets/styles/mixins';
.success {
  color: $success;
}

.error {
  color:$danger;
}
</style>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import moment from "moment";
import { MerchantsResource } from "@/resources/Merchants.resource.js";
export default {
  name: "ListaEquipamentos",
  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 25,
        idMerchant: null,
        idCostCenter: null,
        idSaleChannel: null,
      },
      itens: [],
      costCenters: [],
      saleChannels: [],
      displayItens: [],
      selectedRowKeys: [],
      fields: [
        { key: "idMerchant", label: "#" },
        // { key: "saleChannel", label: "Parceiro" },
        { key: "name", label: "Nome" },
        { key: "birthDate", label: "Nasc" },
        { key: "zipCode", label: "CEP" },
        { key: "number", label: "Numero" },
        { key: "district", label: "Bairro" },
        { key: "street", label: "Logradouro" },
        { key: "socialReason", label: "Razão Social" },
        { key: "managerName", label: "Representante" },
        { key: "managerDocument", label: "Doc Representante" },
        { key: "managerBirthDate", label: "Nasc Representante" },
        { key: "actions", label: "Editar" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 75],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      merchants: [],
      dipositivoEditar: null,
    };
  },
  methods: {
    moment,
    getCostCenters() {
      this.$api
        .get("v1/CostCenter/keyvalue")
        .then((result) => {
          this.costCenters = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    getSaleChannels() {
      this.$api
        .get("v1/saleChannel/keyValue")
        .then((result) => {
          this.saleChannels = result.data.payload;
        })
        .catch((e) => {
          // Surpress
        });
    },
    handleSaleChannelChange() {
      this.filtrosLocal.idCostCenter = null;
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.merchants = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        })
        .catch((e) => {
          // Surpress
        });
    }, 350),
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {
        this.loading = true;

        MerchantsResource.getPendingInformation(this.filtrosLocal)
          .then((result) => {
            try {
              this.itens[this.filtrosLocal.index] = result.data.payload.items;
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = result.data.payload.pageSettings.total;
              this.loading = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            // Surpress
            this.loading = false;
          });
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },
    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a;
      this.getLista();
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 25,
      };
      this.filtrar();
    },
    filtrar() {
      // se algum item do filtro for 0, mudar para null
      this.filtrosLocal.idCostCenter =
        this.filtrosLocal.idCostCenter == 0
          ? null
          : this.filtrosLocal.idCostCenter;
      this.filtrosLocal.idMerchant =
        this.filtrosLocal.idMerchant === 0
          ? null
          : this.filtrosLocal.idMerchant;
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },
    goToEdit(id) {
      this.$router.push({
        path: `/merchant/${id}/edit/`
      });
    },
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0);

        return result;
      } catch (e) {
        return false;
      }
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.filtrar();
  },
  created() {
    if(this.showCostCenter) this.getCostCenters();
    if(this.sysAdminUser) this.getSaleChannels();
  },
};
</script>
